import mergeAudioBlobs from "./mergeAudio"

const FIVE_MB = 2.3 * 1024 * 1024

export async function createFixedMemoryBlobs(listOfBlobs, memorySize = FIVE_MB, finalBlob = false) {
  const groupedBlobs = []
  let currentGroup = []
  let currentSize = 0
  const mergedBlobs = []

  let combinedMemorySizeOfBlobs = 0

  if (!listOfBlobs?.length) return null

  listOfBlobs?.forEach(element => {
    combinedMemorySizeOfBlobs = element?.size + combinedMemorySizeOfBlobs
  })

  if (!finalBlob) {
    if (combinedMemorySizeOfBlobs < memorySize) {
      return null
    }
  }

  for (const blob of listOfBlobs) {
    if (currentSize + blob.size > memorySize && currentGroup.length > 0) {
      groupedBlobs.push([...currentGroup])
      currentGroup = []
      currentSize = 0
    }
    currentGroup.push(blob)
    currentSize += blob.size
  }

  // Push the remaining group if any
  if (currentGroup.length > 0) {
    if (groupedBlobs?.length) {
      groupedBlobs[groupedBlobs?.length - 1] = [...groupedBlobs[groupedBlobs?.length - 1], ...currentGroup]
    } else {
      groupedBlobs.push(currentGroup)
    }
  }

  for (const group of groupedBlobs) {
    const merged = await mergeAudioBlobs(group)
    mergedBlobs.push(merged)
  }

  return mergedBlobs
}
